import validate from 'validate.js'

export const checkCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, '');
  var rev;
  if (cpf === '') return false;
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  )
    return false;
  // Valida 1o digito
  var add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i),10) * (10 - i);
  rev = 11 - add % 11;
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(9), 10)) return false;
  // Valida 2o digito
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i), 10) * (11 - i);
  rev = 11 - add % 11;
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(10), 10)) return false;
  return true;
}

export const checkIMEI = (aux) => {
  const vet = [];
  const verificador = aux[14];
  var a = 0;
  var soma = 0;

  // --- Calcular novo Array --- //
  for (let i = 0; i < 15; i++) {
    vet[i] = aux[i];
    if (i % 2 !== 0) {
      a = aux[i] * 2;
      if (a > 9) {
        let n1 = a % 10;
        let n2 = Math.trunc(a / 10);
        vet[i] = n1 + n2;
      } else {
        vet[i] = parseInt(aux[i], 10) * 2;
      }
    } else {
      vet[i] = parseInt(aux[i], 10);
    }
  } // --- Calcular novo Array --- //
  for (let i = 0; i < 15; i++) {
    soma = soma + vet[i];
  }
  if (soma % 10 !== 0) {
    soma = soma + verificador;
    if (soma % 10 !== 0) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};

export const checkEMAIL = value => {
  return !validate.single(value, {presence: true, email: true});
}

export const checkPASS = value => {
  return !validate.single(value, {presence: true, length: { minimum: 6, maximum: 255}});
}


// WEBPACK FOOTER //
// ./src/libs/Validate.js